import { useContext } from 'react';

import { MultiSelectContext } from '../../components/multi-select/multi-select.context';
import { MultiSelectContextType } from '../types/stateful-list.types';

export function useMultiSelect() {
  const ctx = useContext(MultiSelectContext);
  if (!ctx) throw new Error('useMultiSelect must be used within List.MultiSelect');
  return ctx as MultiSelectContextType;
}
